import { c as _c } from "react/compiler-runtime";
import { LocaleEnum } from '@systemeio/ui';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { HelpScoutArrowIcon } from './help-scout-arrow-icon';
import { HelpScoutQuestionMarkIcon } from './help-scout-question-mark-icon';
const beaconConfig = {
  display: {
    style: 'manual'
  }
};
interface HelpScoutProps {
  shouldRender: boolean;
  locale: LocaleEnum;
}
export function HelpScout(t0) {
  const $ = _c(10);
  const {
    shouldRender,
    locale
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const handleToggle = _temp;
  let t1;
  let t2;
  if ($[0] !== locale || $[1] !== shouldRender) {
    t1 = () => {
      if (!window.Beacon) {
        return;
      }
      if (window.Beacon("info")) {
        window.Beacon("destroy");
      }
      if (!shouldRender) {
        if (window.Beacon("info")) {
          window.Beacon("destroy");
        }
        return;
      }
      const beaconId = locale === LocaleEnum.FRENCH ? "aaa8207b-5330-444e-874f-2932dbd59c04" : "616a9e89-fc77-408c-995e-d7f589d575d7";
      window.Beacon("init", beaconId);
      window.Beacon("config", beaconConfig);
      window.Beacon("on", "open", () => setIsOpen(true));
      window.Beacon("on", "close", () => setIsOpen(false));
      return () => {
        window.Beacon("off", "open");
        window.Beacon("off", "close");
        setIsOpen(false);
      };
    };
    t2 = [shouldRender, locale];
    $[0] = locale;
    $[1] = shouldRender;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Script id="help-scout" dangerouslySetInnerHTML={{
      __html: "!function (e, t, n) {\n          function a() {\n              var e = t.getElementsByTagName(\"script\")[0], n = t.createElement(\"script\");\n              n.type = \"text/javascript\", n.async = !0, n.src = \"https://beacon-v2.helpscout.net\", e.parentNode.insertBefore(n, e)\n              }\n              if (e.Beacon = n = function (t, n, a) {\n                e.Beacon.readyQueue.push({method: t, options: n, data: a})\n                }, n.readyQueue = [], \"complete\" === t.readyState) return a();\n                e.attachEvent ? e.attachEvent(\"onload\", a) : e.addEventListener(\"load\", a, !1)\n                }(window, document, window.Beacon || function () {\n                  });"
    }} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isOpen || $[6] !== shouldRender) {
    t4 = shouldRender && <button onClick={handleToggle} className={twMerge("bg-text-primary fixed -right-2 bottom-16 z-50 flex h-12 w-8 items-center justify-center rounded-l-md pr-2 shadow-lg md:w-14", "transition-transform duration-300 ease-in-out hover:scale-110 hover:shadow-xl", "active:scale-90 md:active:scale-100")}><span className="relative h-full w-full"><span className={twMerge("absolute inset-0 flex transform items-center justify-center transition-all duration-300 ease-in-out", isOpen ? "scale-0 opacity-0" : "scale-100 opacity-100")}><HelpScoutQuestionMarkIcon /></span><span className={twMerge("absolute inset-0 flex transform items-center justify-center transition-all duration-300 ease-in-out", isOpen ? "scale-100 opacity-100" : "scale-0 opacity-0")}><HelpScoutArrowIcon /></span></span></button>;
    $[5] = isOpen;
    $[6] = shouldRender;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp() {
  window.Beacon?.("toggle");
}